/**
 * @generated SignedSource<<d5c08c65ed4abd806e47da1d851a8622>>
 * @relayHash 627a164ed640a00cd8e7321559a066d7
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 627a164ed640a00cd8e7321559a066d7

import type { ConcreteRequest } from 'relay-runtime';
export type IssueFieldDataType = "DATE" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type UpdateIssueIssueTypeInput = {
  clientMutationId?: string | null | undefined;
  issueId: string;
  issueTypeId?: string | null | undefined;
};
export type updateIssueIssueTypeSharedMutation$variables = {
  input: UpdateIssueIssueTypeInput;
};
export type updateIssueIssueTypeSharedMutation$data = {
  readonly updateIssueIssueType: {
    readonly issue: {
      readonly issueType: {
        readonly color: IssueTypeColor;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly isEnabled: boolean;
        readonly name: string;
        readonly pinnedFields: ReadonlyArray<{
          readonly __typename: "IssueFieldDate";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
        } | {
          readonly __typename: "IssueFieldNumber";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
        } | {
          readonly __typename: "IssueFieldSingleSelect";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
        } | {
          readonly __typename: "IssueFieldText";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        }> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueIssueTypeSharedMutation$rawResponse = {
  readonly updateIssueIssueType: {
    readonly issue: {
      readonly id: string;
      readonly issueType: {
        readonly color: IssueTypeColor;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly isEnabled: boolean;
        readonly name: string;
        readonly pinnedFields: ReadonlyArray<{
          readonly __typename: "IssueFieldDate";
          readonly __isNode: "IssueFieldDate";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
        } | {
          readonly __typename: "IssueFieldNumber";
          readonly __isNode: "IssueFieldNumber";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
        } | {
          readonly __typename: "IssueFieldSingleSelect";
          readonly __isNode: "IssueFieldSingleSelect";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
        } | {
          readonly __typename: "IssueFieldText";
          readonly __isNode: "IssueFieldText";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
        } | {
          readonly __typename: string;
          readonly __isNode: string;
          readonly id: string;
        }> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueIssueTypeSharedMutation = {
  rawResponse: updateIssueIssueTypeSharedMutation$rawResponse;
  response: updateIssueIssueTypeSharedMutation$data;
  variables: updateIssueIssueTypeSharedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = [
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dataType",
    "storageKey": null
  }
],
v9 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "IssueFieldText",
  "abstractKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "IssueFieldSingleSelect",
  "abstractKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "IssueFieldDate",
  "abstractKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "IssueFieldNumber",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueIssueTypeSharedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateIssueIssueTypePayload",
        "kind": "LinkedField",
        "name": "updateIssueIssueType",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedFields",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateIssueIssueTypeSharedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateIssueIssueTypePayload",
        "kind": "LinkedField",
        "name": "updateIssueIssueType",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedFields",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "627a164ed640a00cd8e7321559a066d7",
    "metadata": {},
    "name": "updateIssueIssueTypeSharedMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "76d56c8a5faaf2f8168ab652ced0278b";

export default node;
